import * as React from "react";

function SvgIcTools(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path
          fill="currentColor"
          d="M21.047 3.24c-.34-1.064-1.188-2.093-2.546-3.089-.204-.158-.362-.192-.475-.102-.113.09-.136.215-.068.373.023.068.085.379.187.934s.187.934.254 1.137c.271 1.131-.147 1.799-1.256 2.002-.746.113-1.272.039-1.578-.221-.306-.26-.436-.526-.39-.798-.385-1.154-.577-1.867-.577-2.138-.023-.113-.119-.187-.289-.22-.17-.033-.289.051-.356.254-.814 2.082-.973 3.507-.476 4.277.181.316.481.673.899 1.069.418.396.752.798 1.001 1.205.249.407.374.883.374 1.426l.034 2.342-.238 11.658c-.023.476.192.69.645.645h1.562c.385-.023.577-.26.577-.712l-.068-11.42.068-2.715c0-.995.385-1.742 1.154-2.24 1.471-.883 1.991-2.105 1.562-3.666V3.24zm-11.709.51L8.213 0h-2.25L4.838 3.75h1.125v9h-.375a.752.752 0 00-.75.75c0 .413.169.75.375.75s.375.337.375.75-.169.75-.375.75-.375.337-.375.75v6.75c0 .413.338.75.75.75h3c.412 0 .75-.337.75-.75V16.5c0-.413-.169-.75-.375-.75s-.375-.337-.375-.75.169-.75.375-.75.375-.337.375-.75a.752.752 0 00-.75-.75h-.375v-9h1.125z"
        />
      </g>
    </svg>
  );
}

export default SvgIcTools;
